module.exports = __webpack_public_path__ + "img/naples_dark_grey.a64ff62c.jpeg";